import { useState } from "react";

// enum BoatPageLayoutContent {
//   about
//   rates
//   packages
//   additional
//   featureGroup
// }

export const useBoatLayoutContents = () => {
  const data = [
    {
      label: "About Section",
      value: "about",
    },
    {
      label: "Boat Rates Section",
      value: "rates",
    },
    {
      label: "Boat Packages",
      value: "packages",
    },
    {
      label: "Boat Additional information Section",
      value: "additional",
    },
    {
      label: "Feature Section (choose feature group)",
      value: "featureGroup",
    },
    {
      label: "Wharfs Section",
      value: "wharfs",
    },
    {
      label: "Attachments Section",
      value: "attachments",
    },
    {
      label: "Media (only for boat pages with video)",
      value: "media",
    },
    {
      label: "Reviews Section",
      value: "reviews",
    },
  ];

  const [options] = useState(data);
  return options;
};
